import Vue from 'vue';
import Vuelib from '@vuelib';
import router from '@/router';
import store from '@/store';

Vue.use(Vuelib, {
  store,
  router,
  app: {
    name: 'Sync',
    // Tentar sempre utilizar SVG como logo
    logo: () => import('@/assets/logo.svg'),
    version: process.env.VUE_APP_VERSION,
    primaryDark: true,
  },
});
